import { z } from 'zod';

// The board mirrors its active view criteria into the URL search (via usePersistedFilters,
// key `crm:pipeline:${pipelineId}:criteria`); the route validates those keys.
export const boardSearchSchema = z.object({
	stageId: z.string().optional(),
	outcome: z.string().optional(),
	tag: z.string().optional(),
	search: z.string().optional(),
	sort: z.string().optional(),
	order: z.enum(['asc', 'desc']).optional(),
	page: z.coerce.number().optional(),
});
